import React, { useState } from 'react';
import { View, colors } from '@fairygodboss/ui';
import { RadioMic } from '../assets/svgs/RadioMic';
import { buildImagePath } from '../../../../components/JobComponents/Company/Image/logo';

import './animations.scss';

const ExpandableImage = ({
    source = null,
    url,
    name,
    speakerPosition,
    speakerAltText,
    index = 0,
    isExpanded = false,
    expansionHandler,
}) => {
    return (
        <View
            css={{
                flexGrow: '1',
                transition: 'all 300ms ease-in-out',
                height: '461px',
                maxWidth: '368px',
                overflow: 'hidden',
                borderRadius: '20px',
                position: 'relative',
                cursor: 'pointer',
                background: `url(${buildImagePath(source, 'img', {
                    img: 'c_scale,f_auto,q_auto',
                })})`,
                backgroundPosition: 'top',
                backgroundSize: 'cover',
                ...(isExpanded && { flexGrow: '2' }),
            }}
            mr="24px"
            onMouseEnter={() => expansionHandler(index)}
            onClick={() => {
                window.open(url, '_self');
            }}
            title={speakerAltText}
        >
            <div
                style={{
                    position: 'absolute',
                    width: '100%',
                    top: '50%',
                    height: '50%',
                    background:
                        'linear-gradient(179.96deg, rgba(19, 31, 53, 0) 4.2%, rgba(18, 29, 49, 0.16) 4.2%, rgba(19, 31, 53, 0) 4.2%, rgba(11, 17, 29, 0.75) 89.59%)',
                }}
            />
            <View
                css={{
                    position: 'absolute',
                    bottom: '0px',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'nowrap',
                    alignContent: 'center',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-end',
                }}
            >
                <View
                    className={`${
                        isExpanded
                            ? 'radio-images-mic-enter'
                            : 'radio-images-mic-exit'
                    }`}
                    css={{
                        // transition: 'all 300ms ease-in-out',
                        width: '48px',
                        display: 'flex',
                        height: '48px',
                        borderRadius: '24px',
                        backgroundColor: '#fff',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginLeft: '24px',
                        marginBottom: '24px',
                        flexShrink: '0',
                    }}
                >
                    <RadioMic />
                </View>
                <View
                    css={{
                        margin: '0px 16px 12px 16px',
                        marginTop: '0px',
                        alignSelf: 'flex-start',
                        fontFamily: 'Open Sans',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '700',
                        lineHeight: '20px',
                        letterSpacing: '-0.4px',
                        textAlign: 'left',
                    }}
                >
                    <View
                        css={{
                            fontFamily: 'Open Sans',
                            fontSize: '16px',
                            fontStyle: 'normal',
                            fontWeight: '700',
                            lineHeight: '20px',
                            letterSpacing: '-0.4px',
                            textAlign: 'left',
                            color: colors.neutral[0],
                        }}
                    >
                        {name}
                    </View>
                    <View
                        css={{
                            fontFamily: 'Open Sans',
                            fontSize: '14px',
                            fontStyle: 'normal',
                            fontWeight: '400',
                            lineHeight: '18px',
                            letterSpacing: '-0.4px',
                            textAlign: 'left',
                            color: colors.neutral[0],
                        }}
                    >
                        {speakerPosition}
                    </View>
                </View>
            </View>
        </View>
    );
};

export const RadioSpeakerImages = ({
    speaker1Name = 'Wanda Bryant Hope',
    speaker1position = 'Chief DEI Officer, Johnson & Johnson',
    speaker1AltText = 'A headshot of Wanda Bryant Hope, Cheif DEI Officer at Johnson and Johnson. Click to hear her podcast.',
    speaker1url = '/community-podcast/wPS__H8AV/fairygodboss-radio-wanda-bryant-hope',
    speaker1ImgUrl = './Homepage/images/RadioSpeaker1.jpeg',
    speaker2Name = 'Tiffany Dufu',
    speaker2position = 'Founder and CEO, The Cru',
    speaker2AltText = 'A headshot of Tiffany Dufu, the Founder and CEO, The Cru. Click to hear her podcast.',
    speaker2url = '/community-podcast/Ee3I1EAxQ/fairygodboss-radio-tiffany-dufu-founder',
    speaker2ImgUrl = './Homepage/images/RadioSpeaker2.jpeg',
    speaker3Name = 'Katie Warchol',
    speaker3position = 'Financial Advisor, Edward Jones',
    speaker3AltText = 'A headshot of Katie Warchol, Financial Advisor at Edward Jones. Click to hear her podcast. ',
    speaker3url = '/community-podcast/dpLWYwxQm/fairygodboss-radio-katie-warchol-financial',
    speaker3ImgUrl = './Homepage/images/RadioSpeaker3.jpeg',
    ...otherProps
}) => {
    const defaultExpanded = 0;
    const [expandedImageIndex, setExpandedImageIndex] = useState(
        defaultExpanded
    );

    const handleImageExpand = (index) => {
        setExpandedImageIndex(index);
    };

    return (
        <View
            css={{
                flexDirection: 'row',
                flexWrap: 'nowrap',
                alignContent: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                marginLeft: '24px',
            }}
            position="relative"
            onMouseLeave={() => handleImageExpand(defaultExpanded)}
            {...otherProps}
        >
            <ExpandableImage
                source={speaker1ImgUrl}
                url={speaker1url}
                name={speaker1Name}
                speakerPosition={speaker1position}
                speakerAltText={speaker1AltText}
                isExpanded={expandedImageIndex === 0}
                expansionHandler={handleImageExpand}
                index={0}
            />
            <ExpandableImage
                url={speaker2url}
                source={speaker2ImgUrl}
                name={speaker2Name}
                speakerPosition={speaker2position}
                speakerAltText={speaker2AltText}
                isExpanded={expandedImageIndex === 1}
                expansionHandler={handleImageExpand}
                index={1}
            />
            <ExpandableImage
                url={speaker3url}
                source={speaker3ImgUrl}
                name={speaker3Name}
                speakerPosition={speaker3position}
                speakerAltText={speaker3AltText}
                isExpanded={expandedImageIndex === 2}
                expansionHandler={handleImageExpand}
                index={2}
            />
        </View>
    );
};
